import { Badge} from 'react-bootstrap'

const methodBadgeColor = (_method) => {
    switch (_method) {
        case 'GET':
            return 'var(--blue)'
        case 'POST':
            return 'var(--orange)'
        case 'PUT':
            return 'var(--yellow)'
        case 'PATCH':
            return 'var(--yellow)'
        case 'DELETE':
            return 'var(--red)'
        default:
            return 'inherit'
    }
}

const MethodBadge = (props) => {
    if(typeof props.method !== 'string') return null

    const _method = props.method?.toUpperCase()
    
    return <Badge style={{backgroundColor: methodBadgeColor(_method), color: 'var(--white)'}}>{_method}</Badge>
}

const statusCodeBadgeColor = (_code) => {
    if(_code >= 400) return 'var(--red)'
    else if(_code >= 400) return 'var(--pink)'
    else if(_code >= 300) return 'var(--yellow)'
    else if(_code >= 0) return 'var(--green)'
    else return 'var(--dark)'
}

const StatusCodeBadge = (props) => {
    let _code = props.value
    if(typeof _code === 'string'){
        _code = +_code
        if(typeof _code !== 'number') return null
    }
    
    return <Badge style={{backgroundColor: statusCodeBadgeColor(_code), color: 'var(--white)'}}>{_code}</Badge>
}

export {MethodBadge, methodBadgeColor, StatusCodeBadge, statusCodeBadgeColor}